import { useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import actions from '../../actions';
import { setFormData } from '../../actions/forms';
import {
    BigButton,
    Logo,
    Page,
    React,
    Section
} from '../../common';
import {
    getIsFetching,
    getUserRelatives
} from '../../selectors';
import api from '../../services/api';

export const RelativeGrants = Page.register(
    ({
        relativeId,
        isFetching,
        relatives = [],
    }) => {
        const relative = relatives.find((e) => e.profileId === relativeId);
        const {
            profileId,
            grantLevel,
            name,
        } = relative || {};
        const noAccessToVisits = !(grantLevel === 'All' || grantLevel === 'BOOK_VISITS');
        const onPress = async () => {
            await actions.startFetching();
            try {
                await api.updateGrunts([
                    {
                        profileId,
                        level: noAccessToVisits ? 'BOOK_VISITS' : 'VIEW_COVERAGE',
                    },
                ]);
                // syncUserState(() => {
                actions.stopFetching();
                // }, false, false, false);
            } catch (e) {
                console.log('Error while updating grants', e);
                actions.stopFetching();
            } finally {
                setTimeout(() => {
                    actions.stopFetching();
                }, 5000);
            }
        };
        const dispatch = useDispatch();
        const navigator = useNavigation();
        useEffect(() => {
            dispatch(
                setFormData({
                    RelativeGrants: {
                        back: () => {
                            navigator.goBack();
                            return true;
                        },
                    },
                }),
            );
        }, []);
        return (
            <Page
                name="relative-grants"
                isLoading={isFetching}
                safeArea
            >
                <Section centered>
                    <Logo.Wrapper
                        title={noAccessToVisits ? 'titles.allow_visits_management' : 'titles.forbid_visits_management'}
                        subtitle={noAccessToVisits ? 'titles.pressAllow' : 'titles.pressForbidden'}
                        subtitleParams={{ fullName: name }}
                        titleStyle={{ paddingBottom: 12 }}
                    />
                </Section>
                <Section>
                    <BigButton
                        title={noAccessToVisits ? 'buttons.allow' : 'buttons.forbid'}
                        action={onPress}
                        danger={!noAccessToVisits}
                        capitalize
                    />
                </Section>
            </Page>
        );
    },
    {
        isFetching: { from: getIsFetching },
        relatives: { from: getUserRelatives },
    },
);
